import React, {useEffect, useState} from "react";

const OtpInput = ({count = 1, value, onChange, setInputFocus: setInputFocusProps, inputFocus: inputFocusProps}) => {
  const [inputFocus, setInputFocus] = useState(null);

  useEffect(() => {
    if (!inputFocusProps) {
      const element = document.getElementById(inputFocus);
      const isEndInput = element?.classList.contains("end-input");

      if (element?.value && !isEndInput) {
        element.select();
      } else {
        element?.focus();
      }
    } else {
      const element = document.getElementById(inputFocusProps);
      const isEndInput = element?.classList.contains("end-input");

      if (element?.value && !isEndInput) {
        element.select();
      } else {
        element?.focus();
      }
    }
  }, [inputFocus, inputFocusProps]);

  return (
    <div className="mfa-otp-input-container">
      {Array(count).fill("").map((_, index) => {
        return (
          <input
            key={index}
            inputMode="numeric"
            id={`otp-input-${index}`}
            className={`${index + 1 === count ? "end-input" : "basic-input"}`}
            value={value[index]}
            maxLength={1}
            onChange={e => {
              const pattern = /\D/gim;
              const activeElement = document.activeElement;

              if (e.target.value === "") {
                value[index] = e.target.value;
                onChange([...value]);

                if (activeElement) {
                  const nextId = (index - 1);
                  const nextElementId = activeElement.id.slice(0, activeElement.id.lastIndexOf("-") + 1) + nextId;
                  if (nextId >= 0) { // make sure it wont go out of focus
                    setInputFocus(nextElementId);
                    if (setInputFocusProps) {
                      setInputFocusProps(nextElementId);
                    }
                  }
                }
              } else if (!pattern.test(e.target.value)) {
                value[index] = e.target.value;
                onChange([...value]);

                if (activeElement) {
                  const nextElementId = activeElement.id.slice(0, activeElement.id.lastIndexOf("-") + 1) + (index + 1);

                  if (!(index + 1 === count)) { // to make sure it won't go out of focus
                    setInputFocus(nextElementId);
                    if (setInputFocusProps) {
                      setInputFocusProps(nextElementId);
                    }
                  }
                }
              }
            }}
            onClick={e => {
              setInputFocus(e.target.id);
              if (setInputFocusProps) {
                setInputFocusProps(e.target.id);
              }
            }}
            onKeyDown={e => {
              const activeElement = document.activeElement;
              if (e.shiftKey && e.code === "Tab" && activeElement) {
                e.preventDefault();
                const lastDashIndex = activeElement.id.lastIndexOf("-");
                const previousElementId = activeElement.id.slice(0, lastDashIndex + 1) + (Number(activeElement.id.slice(lastDashIndex + 1)) - 1);
                setInputFocus(previousElementId);
                if (setInputFocusProps) {
                  setInputFocusProps(previousElementId);
                }
              }
              if ((e.key === "Backspace" || e.key === "Delete") && e.target.value === "") {
                const lastDashIndex = activeElement.id.lastIndexOf("-");
                const nextId = (Number(activeElement.id.slice(lastDashIndex + 1)) - 1);
                const nextElementId = activeElement.id.slice(0, lastDashIndex + 1) + nextId;
                if (nextId >= 0) { // make sure it wont go out of focus
                  setInputFocus(nextElementId);
                  if (setInputFocusProps) {
                    setInputFocusProps(nextElementId);
                  }
                }
                e.preventDefault();
              }
            }}
          />
        );
      })}
    </div>
  );
};

export default OtpInput;
